
import u from "umbrellajs"
import IntlTelInput from "plugins/intl_tel_input/index"

import {
  getContactInfoData,
} from "app/local_storages/contact_info_storage/index"

import {
  isPresentString,
} from "app/utils/type_checking/index"


interface InputSelector {
  scope?: string | HTMLElement,

  contact_name_input?: string | HTMLElement,
  contact_email_address_input?: string | HTMLElement,
  contact_phone_number_input?: string | HTMLElement,
}
const DEFAULT_SELECTOR = {
  scope: ".cell-new-development-contact-request-box",

  contact_name_input:
    ".cell-new-development-contact-request-box__input-contact_name",
  contact_email_address_input:
    ".cell-new-development-contact-request-box__input-contact_email_address",
  contact_phone_number_input:
    ".cell-new-development-contact-request-box__input-contact_phone_number",
}


const init = (selector?: InputSelector) => {
  const merged_selector = Object.assign({}, DEFAULT_SELECTOR, selector)

  const $scope = u(merged_selector.scope)
  const $contact_name_input = $scope.find(
    merged_selector.contact_name_input,
  )
  const $contact_email_address_input = $scope.find(
    merged_selector.contact_email_address_input,
  )
  const $contact_phone_number_input = $scope.find(
    merged_selector.contact_phone_number_input,
  )

  const local_contact_info_data = getContactInfoData()

  if (local_contact_info_data.contact_name != null &&
    !isPresentString(($contact_name_input.first() as HTMLInputElement).value)) {

    ($contact_name_input.first() as HTMLInputElement).value =
      local_contact_info_data.contact_name
  }
  if (local_contact_info_data.contact_email_address != null &&
    !isPresentString(($contact_email_address_input.first() as HTMLInputElement).value)) {

    ($contact_email_address_input.first() as HTMLInputElement).value =
      local_contact_info_data.contact_email_address
  }
  if (local_contact_info_data.contact_phone_number != null &&
    !isPresentString(($contact_phone_number_input.first() as HTMLInputElement).value)) {

    ($contact_phone_number_input.first() as HTMLInputElement).value =
      local_contact_info_data.contact_phone_number
  }

  IntlTelInput.init().done()
}

export default { init }
